import React from 'react'
import { Helmet } from 'react-helmet-async'
import NewHeroSection from '../components/sections/NewHeroSection'
import WelcomeSection from '../components/sections/WelcomeSection'
import CircleSection from '../components/sections/CircleSection'
import DefiningCraftSection from '../components/sections/DefiningCraftSection'
import UnnamedSection from '../components/sections/UnnamedSection'
import UniquelyYoursSection from '../components/sections/UniquelyYoursSection'
import MemberCaseStudiesSection from '../components/sections/MemberCaseStudiesSection'
import MasterpieceSection from '../components/sections/MasterpieceSection'
import MembershipServicesSection from '../components/sections/MembershipServicesSection'
import OurHeritageSection from '../components/sections/OurHeritageSection'
import EditorialSection from '../components/sections/EditorialSection'

const HomePage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>FGA Prestige - Luxury Fashion & Lifestyle</title>
        <meta name="description" content="Experience the pinnacle of luxury fashion and lifestyle with FGA Prestige. Discover exclusive collections, bespoke shopping experiences, and curated editorial content." />
        <meta property="og:title" content="FGA Prestige - Luxury Fashion & Lifestyle" />
        <meta property="og:description" content="Experience the pinnacle of luxury fashion and lifestyle with FGA Prestige." />
        <meta property="og:url" content="https://fgaprestige.com" />
        <meta property="og:image" content="/og-homepage.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="FGA Prestige Homepage" />
      </Helmet>
      
      <main className="min-h-screen">
        {/* 2. Hero Section with Video Background */}
        <NewHeroSection />
        
        {/* 3. Welcome Section */}
        <WelcomeSection />
        
        {/* 4. A Circle Like No Other */}
        <CircleSection />
        
        {/* 5. Defining Our Craft */}
        <DefiningCraftSection />
        
        {/* 6. Unnamed Section */}
        <UnnamedSection />
        
        {/* 7. Uniquely Yours with Portrait */}
        <UniquelyYoursSection />
        
        {/* 8. Member Case Studies Carousel */}
        <MemberCaseStudiesSection />
        
        {/* 9. Your Life, Our Masterpiece */}
        <MasterpieceSection />
        
        {/* 10. Membership Services Cards */}
        <MembershipServicesSection />
        
        {/* 11. Our Heritage */}
        <OurHeritageSection />
        
        {/* 12. Editorial */}
        <EditorialSection />
      </main>
    </>
  )
}

export default HomePage